import type { FC } from 'react'
import { Fragment, lazy, Suspense } from 'react'

import type { FullScreenPreviewProps } from './FullScreenPreview.types'

const Component = lazy(() => import('./FullScreenPreview'))

/**
 * Lazy loaded version of FullScreenPreview component
 */
export const FullScreenPreview: FC<FullScreenPreviewProps> = (props) => (
  <Suspense fallback={<Fragment />}>
    <Component {...props} />
  </Suspense>
)
